<template>
  <div id="modal_message_bus">
    <modal v-if="active"
           :content="content"
           :confirm-label="confirmLabel"
           :additional-label="additionalLabel"
           :title="title"
           :invert-buttons="true"
           :key="uuid"
           :button1="button1"
           :button2="button2"
           :button3="button3"
           :button1-disabled="() => isButtonDisabled('button1')"
           :button2-disabled="() => isButtonDisabled('button2')"
           :button3-disabled="() => isButtonDisabled('button3')"
           :hint="hint"
           :warning="warning"
           :close-on-click-outside="closeOnClickOutside"
           @confirm="onConfirm"
           @additional="onAdditional"
           @cancel="onCancel">
      <template slot="toggle">
        <hm-input-toggle v-if="doNotShowAgainMessage !== false" v-model="doNotShowAgain" :label="doNotShowAgainMessage" cols="12" />
      </template>
    </modal>
  </div>
</template>

<script>

import { isFunction, isNil, isNumber } from 'lodash';
import uuid from 'uuid';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'ModalMessageBus',

  mixins: [TimerMixin],

  props: {
  },

  data() {
    return {
      content: null,
      active: false,
      cbConfirm: null,
      cbCancel: null,
      title: null,
      doNotShowAgain: false,
      doNotShowAgainMessage: false,
      cbAdditional: null,
      additionalLabel: null,
      confirmLabel: null,
      uuid: uuid.v4(),
      button1: null,
      button2: null,
      button3: null,
      hint: null,
      warning: null,
      closeOnClickOutside: true,
    };
  },

  mounted: function () {
  },

  created: function () {
    this.$on('showModal', (content, cbConfirm, cbCancel = null, title = null, doNotShowAgainMessage = false) => {
      this.active = false;
      this.content = content;
      this.title = title;
      this.cbConfirm = cbConfirm;
      this.cbCancel = cbCancel;
      this.active = true;
      this.doNotShowAgain = false;
      this.doNotShowAgainMessage = doNotShowAgainMessage;
      this.additionalLabel = null;
      this.cbAdditional = null;
      this.confirmLabel = null;
      this.button1 = null;
      this.button2 = null;
      this.hint = null;
      this.warning = null;
      this.uuid = uuid.v4();
      this.closeOnClickOutside = true;
    });

    this.$on('show3ButtonModal', (content, confirmLabel, additionalLabel, cbConfirm, cbAdditional, cbCancel = null, title = null, doNotShowAgainMessage = false) => {
      this.active = false;
      this.content = content;
      this.title = title;
      this.confirmLabel = confirmLabel;
      this.additionalLabel = additionalLabel;
      this.cbConfirm = cbConfirm;
      this.cbAdditional = cbAdditional;
      this.cbCancel = cbCancel;
      this.active = true;
      this.doNotShowAgain = false;
      this.doNotShowAgainMessage = doNotShowAgainMessage;
      this.button1 = null;
      this.button2 = null;
      this.hint = null;
      this.warning = null;
      this.uuid = uuid.v4();
      this.closeOnClickOutside = true;
    });

    this.$on('showModalConfig', (config) => {
      this.active = false;
      this.content = config.content;
      this.title = config.title;
      this.active = true;
      this.doNotShowAgain = config.doNotShowAgain;
      this.doNotShowAgainMessage = config.doNotShowAgainMessage || false;
      this.cbCancel = config.cbCancel;
      this.button1 = {
        color: 'red',
        icon: 'close',
        label: this.$t('modal.cancel'),
        timer: false,
        timerLabel: null,
        ...config.button1,
        onClick: () => { if (!isNil(config.button1) && !isNil(config.button1.onClick)) config.button1.onClick(this.doNotShowAgain); },
      };
      this.button2 = {
        color: 'green',
        icon: 'save',
        label: this.$t('modal.confirm'),
        timer: false,
        timerLabel: null,
        ...config.button2,
        onClick: () => { if (!isNil(config.button2) && !isNil(config.button2.onClick)) config.button2.onClick(this.doNotShowAgain); },
      };

      if (!isNil(config.button3) && config.button3 !== false) {
        this.button3 = {
          color: 'green',
          icon: 'save',
          label: this.$t('modal.confirm'),
          timer: false,
          timerLabel: null,
          ...config.button3,
          onClick: () => { if (!isNil(config.button3) && !isNil(config.button3.onClick)) config.button3.onClick(this.doNotShowAgain); },
        };
      }

      this.hint = config.hint;
      this.warning = config.warning;
      this.uuid = uuid.v4();
      this.closeOnClickOutside = config.closeOnClickOutside !== false;

      this.setButtonTimer('button1');
      this.setButtonTimer('button2');
      this.setButtonTimer('button3');
    });

    this.$serviceBus.$on('navigatedTo', () => {
      this.active = false;
      // no callback, because the page doesn't exist any more - the navigation is done already
    });

    this.$root.modalMessageBus = this;
  },

  beforeRouteLeave: function (to, from, next) {
    this.active = false;
    if (isFunction(this.cbCancel)) this.cbCancel();
    next();
  },

  methods: {
    isNil,
    onConfirm() {
      this.active = false;
      if (isFunction(this.cbConfirm)) this.cbConfirm(this.doNotShowAgain);
    },
    onCancel() {
      this.active = false;
      if (isFunction(this.cbCancel)) this.cbCancel();
    },
    onAdditional() {
      this.active = false;
      if (isFunction(this.cbAdditional)) this.cbAdditional(this.doNotShowAgain);
    },
    setButtonTimer(buttonName, recursive = false) {
      if (!isNil(this[buttonName]) && this[buttonName].timer && isNumber(this[buttonName].timer)) {
        if (!recursive) {
          this[buttonName].timerLabel = this[buttonName].label;
          this[buttonName].timerIcon = this[buttonName].icon;
          this[buttonName].icon = 'clock';
        }

        this[buttonName].label = `${this.$t('modal.wait')} (${this[buttonName].timer})`;
        this[buttonName].disabled = true;

        this[`${buttonName}Timer`] = this.setTimeout(() => {
          if (!isNil(this[buttonName])) {
            this[buttonName].timer--;
            if (isNumber(this[buttonName].timer) && this[buttonName].timer <= 0) {
              this[buttonName].disabled = false;
              this[buttonName].timer = false;
              this[buttonName].label = this[buttonName].timerLabel;
              this[buttonName].icon = this[buttonName].timerIcon;
            } else {
              this.setButtonTimer(buttonName, true);
            }
          }
        }, 1000);
      }
    },
    isButtonDisabled(buttonName) {
      if (isNil(this[buttonName])) return false;
      return this[buttonName].disabled || false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/lib/util/ModalMessageBus.vue